<div id="irt-users-root-layout" class="irt-full-height">
  <app-toolbar class="irt-toolbar" [currentItem]="navbarItem"></app-toolbar>
  <app-navbar class="irt-navbar" [currentItem]="navbarItem"></app-navbar>
  <app-users-section class="irt-section"></app-users-section>
</div>